<template>
    <v-app class="fondo">
        <v-toolbar class="primary" dark app fixed clipped-left dense>
            <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
                <v-avatar size="35px">
                    <img :src="'./img/iso-gltn-blanco.svg'" alt="avatar">
                </v-avatar>
                Grupo LTN
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="logout()">
                <v-icon class="red--text">fa-sign-out-alt</v-icon>
            </v-btn>
            <!--<loading></loading>-->
        </v-toolbar>
        <v-content>
            <v-container fluid id="contenedor-principal">
                <v-layout>
                    <router-view></router-view>
                </v-layout>
            </v-container>
        </v-content>
        <!--///////////////////////////////////  MENSAJES DE ERRORES  ////////////////////////////////////////////////-->
        <v-snackbar @input="msjEstado($event)" :value="msj.mostrar" :color="msjColor">
            {{ msj.txt }}
            <v-btn dark flat @click.native="msjEstado(false)" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </v-app>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'app-layout',
        data() {
            return {
                dbName: window.Laravel.dbName,
            };
        },
        computed:{
            ...mapGetters('notif', ['msj']),
        },
        methods: {
            ...mapActions('notif', ['msjSetEstado']),
            msjEstado(valor) {
                this.msjSetEstado(valor);
            },
            logout() {
                this.$http.post('logout')
                    .then(r => {
                        this.$ls.remove('token');
                        this.$store.dispatch('auth/unsetAuthUser');
                        this.$router.push('/login');
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    };
</script>
<style scoped>
    .progress-linear {
        position: absolute;
        margin: 0;
        bottom: 0;
    }
    .fondo{
        background: linear-gradient(to top, rgb(130, 143, 152), rgb(29, 26, 21));
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/layouts/sinmenu.vue